import {
  FaqsService
} from '@/common/api.service'
import {
  FETCH_FAQ,
  FETCH_FAQS
} from './actions.type'
import {
  FETCH_START,
  FETCH_END,
  FETCH_END_INFINITE,
  SET_ITEM,
  CLEAR_FAQ
} from './mutations.type'

const state = {
  faq: {},
  faqs: []
}

const getters = {
  faq (state) {
    return state.faq
  },
  faqs (state) {
    return state.faqs
  }
}

const actions = {
  [FETCH_FAQS] ({ commit }, params) {
    if (!params.infiniteScroll) {
      commit(FETCH_START)
    }
    return FaqsService.query(params.type, params.filters)
      .then(({ data }) => {
        let collection = { data }
        if (!params.infiniteScroll) {
          commit(FETCH_END, collection)
        } else {
          commit(FETCH_END_INFINITE, collection)
        }
      })
      .catch((error) => {
        throw new Error(error)
      })
  },
  [FETCH_FAQ] ({commit}, id) {
    return FaqsService.get(id)
      .then(({ data }) => {
        commit(SET_ITEM, data)
      })
  }
}

/* eslint no-param-reassign: ["error", { "props": false }] */
const mutations = {
  [FETCH_START] (state) {
    state.isLoading = true
  },
  [FETCH_END] (state, faqs) {
    state.faqs = faqs.data
    state.isLoading = false
  },
  [SET_ITEM] (state, faq) {
    console.log(faq)
    state.faq = faq
    state.isLoading = false
  },
  [CLEAR_FAQ] (state) {
    state.faq = {}
    state.isLoading = false
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
